import React, { useEffect, useState } from "react";

import Button from "../../../../components/Button";
import Input from "../../../../components/Inputs/InputText";
import LongText from "../../../../components/Inputs/LongText";
import Modal from "../../../../components/Modal";
import Typography from "../../../../components/Text";

import css from "../CompanyLinksModal.module.scss";

const AddEditLinkModal = ({ show, onClose, onSubmit, selectedLink }: any) => {
	if (!show) {
		return <></>;
	}

	const [url, setUrl] = useState("");
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");

	useEffect(() => {
		setUrl(selectedLink?.url || "");
		setTitle(selectedLink?.title || "");
		setDescription(selectedLink?.description || "");
	}, [selectedLink]);

	const onSubmitForm = () => {
		onSubmit({ url, title, description });
	};

	const validatedUrl = !!url.match(/^(ftp|ftps|http|https):\/\/[^ "]+$/);

	const deleteButtons = [
		<Button
			key={2}
			size="large"
			className={css.button}
			onClick={onSubmitForm}
			color="green"
			disabled={!validatedUrl}
			testid="add-edit-link-modal-submit-button"
		>
			{selectedLink ? "Edit Link" : "Add Link"}
		</Button>,
	];

	const content = (
		<div className={css.editModalContent}>
			<div className={css.inputWrapper}>
				<Input
					value={url}
					onChange={(val) => {
						setUrl(val);
					}}
					label="URL"
					placeholder="URL"
					showWarning={!!(url && !validatedUrl)}
					errorMessage={url && !validatedUrl ? "Invalid URL" : ""}
					testId="url-input"
				/>
			</div>
			<div className={css.inputWrapper}>
				<Input
					value={title}
					label="Title"
					onChange={(val) => {
						setTitle(val);
					}}
					placeholder="Title"
					testId="title-input"
				/>
			</div>
			<div className={css.inputWrapper}>
				<div className={css.inputTitleWrapper}>
					<Typography size="paragraph-2" weight="semi-bold">
						Description
					</Typography>
					<div className={css.spacer} />
				</div>
				<LongText
					value={description}
					onChange={(val) => {
						setDescription(val);
					}}
					placeholder="Description"
					className={css.textareaInput}
					testId="description-input"
				/>
			</div>
		</div>
	);

	return <Modal content={content} handleClose={onClose} buttons={deleteButtons} />;
};

export default AddEditLinkModal;
